import service from "@/utils/request";

// 手机号码登录
interface loginData {
  mobile: string;
  code: string;
}
export const login = (data: loginData) => {
  return service({
    url: "/api/v1/staff/login/mobile",
    method: "post",
    data,
  });
};

// 退出登录
export const logout = () => {
  return service({
    url: "/api/v1/staff/logout",
    method: "post",
  });
};

// 获取用户信息
export const getUserInfo = () => {
  return service({
    url: "/api/v1/staff/org",
    method: "get",
  });
};

// 添加员工
interface createStaffData {
  name: string;
  mobile: string;
  avatar?: string;
  sex?: number;
  subjects?: number[];
  is_teach: number;
  is_live: number;
  teach_machine: number;
  roles: number[];
  remark?: string;
}
export const createStaff = (data: createStaffData) => {
  return service({
    url: "/api/v1/staff/create",
    method: "post",
    data,
  });
};

// 编辑员工
interface editStaffData {
  name: string;
  mobile: string;
  avatar?: string;
  sex?: number;
  subjects?: number[];
  is_teach: number;
  is_live: number;
  teach_machine: number;
  roles: number[];
  remark?: string;
  staff_id: number;
}
export const editStaff = (data: editStaffData) => {
  return service({
    url: "/api/v1/staff/modify/info",
    method: "post",
    data,
  });
};

// 员工列表
export interface getStaffListData {
  page: number;
  page_size: number;
  key_word?: string;
  on_job?: number;
  is_teach?: number;
  job_id?: number;
  directly_under?: number;
  resignation_time_start?: number;
  resignation_time_end?: number;
}
export const getStaffList = (params: getStaffListData) => {
  return service({
    url: "/api/v1/staff/list",
    method: "get",
    params,
  });
};

// 修改员工在职状态
interface setStaffStatusData {
  staff_id: number;
  on_job: number;
}
export const setStaffStatus = (data: setStaffStatusData) => {
  return service({
    url: "/api/v1/staff/modify/status",
    method: "post",
    data,
  });
};

// 修改员工显示状态
interface setStaffVisibleData {
  staff_id: number;
  is_show: number;
}
export const setStaffVisibleApi = (data: setStaffVisibleData) => {
  return service({
    url: "/api/v1/staff/modify/show",
    method: "post",
    data,
  });
};

// 切换登录
interface switchLoginData {
  org_id: number;
}
export const switchLogin = (data: switchLoginData) => {
  return service({
    url: "/api/v1/staff/login/change",
    method: "post",
    data,
  });
};

// 删除员工
interface deleteStaffData {
  staff_id: number;
}
export const deleteStaff = (data: deleteStaffData) => {
  return service({
    url: "/api/v1/staff/del",
    method: "post",
    data,
  });
};

// 获取员工授权菜单
export const getStaffMenu = () => {
  return service({
    url: "/api/v1/staff/menu",
    method: "get",
  });
};

// 员工详情
interface getStaffDetailData {
  staff_id: number;
  org_id?: number;
}
export const getStaffDetail = (params: getStaffDetailData) => {
  return service({
    url: "/api/v1/staff/detail",
    method: "get",
    params,
  });
};

// 超管登录
interface adminLoginData {
  bg_token: string;
}
export const adminLogin = (data: adminLoginData) => {
  return service({
    url: "/api/v1/staff/login/super",
    method: "post",
    data,
  });
};
// 超管门店列表
export const adminOrgListApi = (params?: { org_name?: string }) => {
  return service({
    url: "/api/v1/staff/super/org_list",
    method: "get",
    params,
  });
};

// 获取短信验证码
interface captchaData {
  mobile: string;
  event: string;
  area_code: string;
}
export const captcha = (data: captchaData) => {
  return service({
    url: "/api/v1/sms/send",
    method: "post",
    data,
  });
};

// 组织其他门店未关联员工列表
interface getUnrelateStaffListData {
  page: number;
  page_size: number;
  key_word: string;
  org_id: number;
}
export const getUnrelateStaffList = (params: getUnrelateStaffListData) => {
  return service({
    url: "/api/v1/staff/inst/not_relation/list",
    method: "get",
    params,
  });
};

// 扫码登录-获取二维码
export const getLoginQrCodeApi = (params: { type: string }) => {
  return service({
    url: "/api/v1/staff/login/qrcode/get",
    method: "get",
    params,
  });
};

// 扫码登录-检查二维码状态
export const getLoginQrCodeCheckStatusApi = (data: {
  type: string;
  code: string;
}) => {
  return service({
    url: "/api/v1/staff/login/qrcode/check_status",
    method: "post",
    data,
  });
};
